import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setLink = (rel, href) => {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
};

export default function SEO({ title, description, keywords, path = "/", jsonLd }) {
    useEffect(() => {
        const fullTitle = title
            ? `${title} | TrustHer Home`
            : "TrustHer Home | Women-Owned Home Services Directory";
        document.title = fullTitle;

        setMeta("description", description);
        setMeta("keywords", keywords);
        setMeta("og:title", fullTitle, "property");
        setMeta("og:description", description, "property");
        setMeta("og:type", "website", "property");
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", fullTitle);
        setMeta("twitter:description", description);

        const origin = typeof window !== "undefined" ? window.location.origin : "";
        setLink("canonical", `${origin}${path}`);
        setMeta("og:url", `${origin}${path}`, "property");

        if (jsonLd) {
            setJsonLd(`jsonld-${path.replace(/\W/g, "_")}`, jsonLd);
        }
    }, [title, description, keywords, path, jsonLd]);

    return null;
}
